/**
 * Defines Discord State interface
 * */

import { DiscordIntegration } from "../projects/types";

export interface DiscordState {
    httpInProgress: boolean;
    httpUpdateInProgress: boolean;
    httpError: string;
}
      
/**
 * * Defines Discord actions names
 * */
export const DISCORD_IN_PROGRESS = 'DISCORD_IN_PROGRESS'
export const DISCORD_UPDATE_IN_PROGRESS = 'DISCORD_UPDATE_IN_PROGRESS'
export const DISCORD_ERROR = 'DISCORD_ERROR'
export const DISCORD_SUCCESS = 'DISCORD_SUCCESS'
      
/**
 * * Defines Discord actions interfaces
 * */

interface DiscordInProgressAction {
    type: typeof DISCORD_IN_PROGRESS;
}

interface DiscordUpdateInProgressAction {
    type: typeof DISCORD_UPDATE_IN_PROGRESS;
}

interface DiscordErrorAction {
    type: typeof DISCORD_ERROR;
    error: string;
}

interface DiscordSuccessAction {
    type: typeof DISCORD_SUCCESS;
}
  
/**
 * * Defines all suported actions for Discord
 * */
  
export type DiscordActionTypes =
    DiscordInProgressAction |
    DiscordUpdateInProgressAction |
    DiscordErrorAction |
    DiscordSuccessAction
  
/**
 * * Defines DiscordActionsInterface
 * */
  
export interface DiscordActionsInterface {
    discordAssign: (projectID: string, webHookURL: string) => void;
    discordRevoke: (projectID: string ) => void;
    discordUpdate: (projectID: string, discordIntegration: DiscordIntegration) => void;
}